import { Button } from '@altify/components';
import { ActiveProductDtoTypeEnum } from 'services/generated';
import { useGetProductDetailsQuery } from 'store/slices/products-api';
import { OrderTypeModalCallable } from 'app/_authenticated/trade/components/OrderTypeModal/OrderTypeModal';

export function PortfolioActionButton({
  productCode,
  productType,
  isBuyable,
  isSellable,
}: {
  productCode: string;
  productType: ActiveProductDtoTypeEnum;
  isBuyable: boolean;
  isSellable: boolean;
}) {
  const { subscribeLink, redeemLink } =
    productType === ActiveProductDtoTypeEnum.PrivateCredit
      ? getPrivateCreditLinks(productCode)
      : { subscribeLink: undefined };
  return (
    <div className="flex flex-row gap-2 justify-end">
      {isBuyable ? (
        <Button
          size="medium"
          className="px-4"
          onPress={() => {
              OrderTypeModalCallable.call({
                productCode,
                filter: 'buy',
              });
          }}
          fullWidth={false}
          text={'Buy'}
        />
      ) : null}
      {isSellable || redeemLink ? (
        <Button
          size="medium"
          color="secondary"
          className="px-4"
          onPress={() => {
            productType === ActiveProductDtoTypeEnum.PrivateCredit &&
            subscribeLink
              ? window.open(redeemLink, '_blank')
              : OrderTypeModalCallable.call({
                  productCode,
                  filter: 'sell',
                });
          }}
          fullWidth={false}
          text={
            productType === ActiveProductDtoTypeEnum.PrivateCredit
              ? 'Redeem'
              : 'Sell'
          }
        />
      ) : null}
    </div>
  );
}

const getPrivateCreditLinks = (
  productCode: string,
): {
  redeemLink?: string;
  subscribeLink?: string;
} => {
  const { data: productDetails } = useGetProductDetailsQuery(productCode);
  return {
    redeemLink: productDetails?.productCopy?.redeemLink,
    subscribeLink: productDetails?.productCopy?.earlyAccessLink,
  };
};
